import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetCourtsBySearch(club, url) {

  var url = "/reservation/get_courts_by_search/" + club + url; 

  return FetchGetDataWithAuthNEW(url);
}

